export const servicios = [
    {    
    "nombre": "Entrega de paquetes de Conejos.",
    "enlace": "https://ruts.hidalgo.gob.mx/ver/609",
    "area": "Dirección General de Ganadería"        
},
{    
    "nombre": "Capacitación Acuícola y Pesquera",
    "enlace": "https://ruts.hidalgo.gob.mx/ver/674",
    "area": "Dirección de Acuacultura"        
},
{
     "nombre": "Componente Rehabilitación, Modernización, Tecnificación, Equipamiento de Unidades de Riego y Proyectos Productivos en Zonas de Atención Prioritaria.",
    "enlace": "https://ruts.hidalgo.gob.mx/ver/7632",
    "area": "Director General de Agricultura e Infraestructura Hidroagrícola"       
},
{
    "nombre": "Asesoría para el Desarrollo de Productos y la Comercialización en Agronegocios.",
   "enlace": "https://ruts.hidalgo.gob.mx/ver/8860",
   "area": "Dirección de Mercadotecnia"       
},
{
    "nombre": "Capacitación en elaboración de quesos y derivados lácteos.",
   "enlace": "https://ruts.hidalgo.gob.mx/ver/1575",
   "area": "Dirección General de Fomento Lechero"       
},
{
    "nombre": "Componente Equipamiento de Distritos de Riego.",
   "enlace": "https://ruts.hidalgo.gob.mx/ver/7629",
   "area": "Director General de Agricultura e Infraestructura Hidroagrícola"       
},
{
    "nombre": "Captación de Leche en Centros de Acopio.",
   "enlace": "https://ruts.hidalgo.gob.mx/ver/1781",
   "area": "Dirección General de Fomento Lechero"       
},
{
    "nombre": "Capacitación en Inseminación Artificial en Bovinos leche.",
   "enlace": "https://ruts.hidalgo.gob.mx/ver/1574",
   "area": "Dirección General de Fomento Lechero"       
},
{
    "nombre": "Capacitación en Nutrición y Manejo de Ganado Lechero.",
   "enlace": "https://ruts.hidalgo.gob.mx/ver/1573",
   "area": "Dirección General de Fomento Lechero"       
},
{
    "nombre": "Componente Rehabilitación, Modernización y Tecnificación de Distritos de Riego.",
   "enlace": "https://ruts.hidalgo.gob.mx/ver/7628",
   "area": "Dirección General de Agricultura e Infraestructura Hidroagrícola"       
},
{
    "nombre": "Laboratorio de Constatación de Leche.",
   "enlace": "https://ruts.hidalgo.gob.mx/ver/1780",
   "area": "Unión Ganadera Regional de Hidalgo"       
},
{
    "nombre": "Asesoría presencial y a distancia para la Constitución de Sociedades Agropecuarias y Pesqueras.",
   "enlace": "https://ruts.hidalgo.gob.mx/ver/8863",
   "area": "Dirección de Vinculación Empresarial"       
},
{
    "nombre": "Siembra de Crías de Peces.",
   "enlace": "https://ruts.hidalgo.gob.mx/ver/8867",
   "area": "Dirección de Acuacultura"       
},
{
    "nombre": "Constitución de Grupos de Productores de Leche.",
   "enlace": "https://ruts.hidalgo.gob.mx/ver/1572",
   "area": "Dirección General de Fomento Lechero"       
},
{
    "nombre": "Asistencia Técnica y Capacitación Pecuaria.",
   "enlace": "https://ruts.hidalgo.gob.mx/ver/8865",
   "area": "Dirección General de Ganadería"       
},
{
    "nombre": "Asesoría para el trámite de la membresía GS1 para la trazabilidad en productos agropecuarios.",
   "enlace": "https://ruts.hidalgo.gob.mx/ver/8862",
   "area": "Dirección de Mercadotecnia"       
},
// {
//     "nombre": "Plataforma de Comercialización Agropecuaria (Tianguis SEDAGROH)",
//    "enlace": "https://ruts.hidalgo.gob.mx/ver/8882",
//    "area": "Dirección de Innovación y Sistema"       
// },
{
    "nombre": "Asesoría técnica, especializada en agricultura sustentable.",
   "enlace": "https://ruts.hidalgo.gob.mx/ver/9075",
   "area": "Centro de Innovación y Desarrollo Tecnológico del Valle del Mezquital"       
},
{
    "nombre": "Préstamo con maquinaria especializada para la nivelación de tierras agrícolas.",
   "enlace": "https://ruts.hidalgo.gob.mx/ver/9974",
   "area": "Dirección General de Agricultura e Infraestructura Hidroagrícola"       
},
// {
//     "nombre": "Agricultura de precisión con Dron.",
//    "enlace": "https://ruts.hidalgo.gob.mx/ver/9982",
//    "area": "Dirección General de Agricultura e Infraestructura Hidroagrícola"       
// },
{
    "nombre": "Servicios y Entrega de Apoyos Sobre la Cadena Productiva de Café.",
   "enlace": "https://ruts.hidalgo.gob.mx/ver/10661",
   "area": "Dirección de Cafeticultura"       
},
{
    "nombre": "Gestión de Créditos.",
   "enlace": "https://ruts.hidalgo.gob.mx/ver/10927",
   "area": "Dirección de Fomento al Credito"       
}

]
export const sinternos_item = [
    // {
    //     "sinternos_item_nombre" : "Sistema de Ventanilla Única de la SADERH.",
    //     "sinternos_item_url" : "https://sedagrohidalgo.site/"
    // },
    {
        "sinternos_item_nombre" : "Servicios de la Subsecretaria de Agronegocios.",
        "sinternos_item_url" : "http://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SEDAGROH/Transparencia/Rubros/45/Tarjetaagronegocios.pdf"
    },
    {
        "sinternos_item_nombre" : "Aviso de Privacidad",
        "sinternos_item_url" : "https://transparenciadocs.hidalgo.gob.mx/dependencias/agricultura/dir1/SADERH/2025/Interes/AvisoPrivacidad.pdf"
    },

]